const audit = {
  title: "Аудит кода — Мульти-ревью",
  subtitle: "Обзор кода с 4 сторон: план, реальность, качество и целостность",
  backToAdmin: "Назад в журнал разработки",
  passed: "Пройдено",
  warnings: "Предупреждения",
  failures: "Ошибки",
  infoItems: "Информация",
  totalChecks: "Всего проверок",
  filterBy: "Фильтр по",
  filterAll: "Все",
  noChecks: "Нет проверок для отображения",
  summaryTitle: "Сводка по ролям",
  hat: "Роль",
  score: "Оценка",
  overall: "Общий",
  resultPass: "Пройдено",
  resultWarn: "Предупреждение",
  resultFail: "Ошибка",
  resultInfo: "Информация",
  recommendation: "Рекомендация:",
  passCount: "пройдено",
  warnCount: "предупр.",
  failCount: "ошибки",
  infoCount: "инфо",
  totalLabel: "Всего",
} as const;
export default audit;
